import { createContext, useContext } from 'react';

export interface YarAccess {
  readonly slug: string;
  /** From shell-context; `null` while unknown or when the subscription could not be read (fails closed). */
  readonly subscriptionMode: 'trial' | 'paid' | null;
}

const YarAccessContext = createContext<YarAccess>({ slug: '', subscriptionMode: null });

export const YarAccessProvider = YarAccessContext.Provider;
export const useYarAccess = (): YarAccess => useContext(YarAccessContext);
